export default "__VITE_ASSET__LroM$Sae__"